import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class DocumentTmpModel extends BaseModel {

    constructor() {
        super({ 
                name: "documentTmp",
                tableName: 'document_temp',
                label: "Nhập văn bản", 
                display_key: 'code',
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                display: false
            },
            code: {
                name: 'code',
                type: "String",
                label: 'Mã VB hệ thống',
                width: 7,
                class: "center",
                style: 'word-wrap:break-word',
                filter: { type: 'input', match: 'contains'},
                // display: false
            }
        },)
    }

}